import IStepFifthModel from './IStepFifthModel';

const StepFifthModelInitialState: IStepFifthModel = {
  codeMelliBimehGozar: null,
  tarikhTavalodBimehGozar: null,
  naamBimehGozar: null,
  namKhanevadegiBimehGozar: null,
  jensiatiBimehGozar: null,
  loggedInUserIsBimehGozar: true,
  hasEstelamSabtAhval: null,
  codeMelliSabtAhval: null,
  tarikhTavaloodSabtAhval: null,
  serialPelak: null,
  serialPelakCoreId: null,
  shomarehEntezami1: null,
  shomarehEntezami2: null,
  shomarehEntezami3: null,
};

export default StepFifthModelInitialState;
